module.exports = __webpack_public_path__ + "img/queso.209a73f6.jpg";